import axios from 'axios'
import bus from '@/assets/js/bus.js'
export default {
  apiPost(url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }).catch((response) => {
        resolve(response)
        bus.$message({
          message: 'ネットワークをチェックしてください。',
          type: 'warning'
        })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/base_http.js